import './Problem.css'

const painPoints = [
  {
    icon: <MapIcon />,
    title: 'Lost in Strategy',
    body: 'You\'ve had the workshops, read the frameworks, maybe hired a consultant who left you a roadmap. But nothing has shipped. The gap between strategy and working software remains as wide as ever.',
  },
  {
    icon: <WrenchIcon />,
    title: 'Pilots That Never Scaled',
    body: 'A proof-of-concept looked promising — then stalled. Integrating AI with your real data, real systems, and real compliance requirements turned out to be harder than the demo made it look.',
  },
  {
    icon: <ClockIcon />,
    title: 'The Landscape Moves Too Fast',
    body: 'By the time your team evaluates one approach, three more have emerged. Without a trusted guide who has actually built in production, it\'s easy to invest in the wrong thing at the wrong time.',
  },
]

export default function Problem() {
  return (
    <section className="problem section" id="problem">
      <div className="container">
        <div className="problem__header">
          <span className="section-eyebrow">The Challenge</span>
          <h2 className="section-heading">
            Most businesses know they need AI.<br />
            Few know where to actually start.
          </h2>
          <p className="section-subtext problem__intro">
            The organisations we work with are smart, ambitious, and serious about AI adoption.
            What they lack isn&rsquo;t intent — it&rsquo;s a partner who can translate that intent into
            production software.
          </p>
        </div>

        <div className="problem__cards">
          {painPoints.map((p, i) => (
            <article className="problem__card" key={i}>
              <div className="problem__card-icon">{p.icon}</div>
              <h3 className="problem__card-title">{p.title}</h3>
              <p className="problem__card-body">{p.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}

function MapIcon() {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21"/>
      <line x1="9" y1="3" x2="9" y2="18"/>
      <line x1="15" y1="6" x2="15" y2="21"/>
    </svg>
  )
}

function WrenchIcon() {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
    </svg>
  )
}

function ClockIcon() {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/>
      <polyline points="12 6 12 12 16 14"/>
    </svg>
  )
}
